import { FormSectionDto } from "@green0meter/api-client";
import { FieldValues } from "react-hook-form";

export const isStepValid = (
  section: FormSectionDto,
  values: FieldValues,
): boolean => {
  const requiredQuestionsWithoutAnswer = section.formQuestions?.filter(
    (question) =>
      question.isRequired &&
      question.isVisible &&
      (values[question.code] === undefined ||
        values[question.code] === "" ||
        values[question.code] === null),
  );

  const sectionHasErrors =
    requiredQuestionsWithoutAnswer && requiredQuestionsWithoutAnswer.length > 0;

  return !sectionHasErrors;
};
